<template>
  <div class="bg-FFFFFF form-item">
    <div class="DDSelectField" v-if="component_name === 'DDSelectField'">
      <common-select-input-box
        class="select-label bg-FFFFFF mt-12 p-12-0"
        :label-width="180"
        :label="itemProps.label"
        :value="value"
        :required="itemProps.required"
        @click="radioClick"
        :placeholder="itemProps.placeholder || '请选择'"
        :show-slot="!!value"
      >
        <div slot="commonRight" class="mt-6 fb fb-cross-center fb-main-start">
          <span class="c-171A1D-80">{{
            filterName(`${value} `, 7, '...', false)
          }}</span
          ><i
            v-show="value"
            class="iconfont font-32 mt-3 img-item-clear"
            @click.stop="handleRadioClear"
            >&#xe720;</i
          >
        </div>
      </common-select-input-box>
    </div>
    <div
      class="DDMultiSelectField"
      v-if="component_name === 'DDMultiSelectField'"
    >
      <common-select-input-box
        class="select-label bg-FFFFFF mt-12 p-12-0"
        :label-width="180"
        :label="itemProps.label"
        :value="value | filterCheckboxText"
        :required="itemProps.required"
        @click="checkboxClick"
        :placeholder="itemProps.placeholder || '请选择'"
      ></common-select-input-box>
    </div>
    <div
      class="normal-item TextareaField"
      v-if="component_name === 'TextareaField'"
    >
      <div class="label" :class="{ required: itemProps.required }">
        <span>{{ itemProps.label }}</span>
      </div>
      <div>
        <textarea
          v-model="formValue"
          rows="3"
          :maxlength="100"
          :placeholder="itemProps.placeholder || '请输入'"
        ></textarea>
      </div>
    </div>
    <div
      class="normal-item DDPhotoField"
      v-if="component_name === 'DDPhotoField'"
    >
      <div class="label" :class="{ required: itemProps.required }">
        <span>{{ itemProps.label }}</span>
      </div>
      <div>
        <common-upload-img
          :imgs="DDPhotoFieldImageList"
          @error="handlerImgSelectError"
          @change="handlerImgChange"
        ></common-upload-img>
      </div>
    </div>

    <md-popup v-model="checkboxOpen" :maskClosable="true" position="bottom">
      <div class="p-16-0" v-if="checkboxOpen">
        <div class="p-0-16 pb-12 fb fb-cross-center fb-main-between">
          <span class="c-006AFE iconfont" @click="checkboxOpen = false"
            >取消</span
          >
          <span class="c-006AFE" @click="checkboxConfirm">确认</span>
        </div>
        <div class="pt-16 p-0-16 pb-48">
          <div
            class="bt p-6-0 fb fb-cross-center fb-main-start"
            v-for="(item, index) in checkboxList"
            :key="item.label"
          >
            <md-checkbox
              v-model="checkboxList[index].check"
              circle
              :label="item.label"
            ></md-checkbox>
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { commonSelectInputBox, commonUploadImg } from '@/components'
import { filterName } from '@/utils/comUtils'
import { mcAlert } from '@/utils/mcSdkUtils'
export default {
  name: 'leaveFormItem',
  components: {
    commonSelectInputBox,
    commonUploadImg
  },
  props: {
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      filterName,
      checkboxOpen: false, // 复选框弹窗显示
      checkboxList: [] // 复选框数据
    }
  },
  filters: {
    filterCheckboxText(val) {
      let value = val
      if (typeof val === 'string') {
        try {
          value = JSON.parse(`${val}` || '')
        } catch (err) {}
      }
      if (!value || !value.length) {
        return ''
      } else if (value.length === 1) {
        return value[0]
      } else {
        return `${value[0]}...等${value.length}个选项`
      }
    }
  },
  watch: {
    checkboxOpen(val) {
      this.$emit('popupShowChange', val)
    }
  },
  computed: {
    formValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    component_name() {
      return this.$attrs.component_name
    },
    itemProps() {
      return this.$attrs.props
    },
    // 图片的默认列表
    DDPhotoFieldImageList() {
      let value = this.value
      if (typeof this.value === 'string') {
        try {
          value = JSON.parse(`${this.value}` || '')
        } catch (err) {}
      }
      if (
        this.component_name === 'DDPhotoField' &&
        value &&
        Array.isArray(value) &&
        value.length
      ) {
        if (typeof value[0] === 'string') {
          return value.map((ele, index) => ({
            id: index,
            previewImgURL: ele
          }))
        }
        return value
      }
      return []
    }
  },

  methods: {
    // 单选点击
    radioClick() {
      const _that = this
      this.$Picker({
        $props: {
          columns: _that.itemProps.options,
          defaultActive: 0
        },
        $events: {
          confirm(index, value) {
            _that.$emit('input', value[0])
          }
        }
      }).show()
    },
    // 多选点击
    checkboxClick() {
      this.checkboxList = this.itemProps.options.map(ele => ({
        label: ele,
        check: (this.value || []).includes(ele)
      }))
      this.checkboxOpen = true
    },
    // 多选确定
    checkboxConfirm() {
      const data = this.checkboxList
        .filter(ele => ele.check)
        .map(ele => ele.label)
      this.$emit('input', data)
      this.checkboxOpen = false
    },
    handlerImgChange(val) {
      this.$emit('input', val)
    },
    /**
     * 选择图片失败回调
     */
    handlerImgSelectError(err) {
      mcAlert({ msg: (err && err.message) || '失败' })
    },
    handleRadioClear() {
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.select-label) {
  span {
    line-height: 18px;
  }
}
.form-item {
  .normal-item {
    background-color: #fff;
    margin-top: 12px;
    padding: 12px 0;
    position: relative;
    .label {
      padding-bottom: 12px;
      &.required::before {
        content: '*';
        display: inline;
        position: absolute;
        top: 2px;
        left: -12px;
        color: #f25643;
        font-size: 26px;
      }
    }
  }
}
</style>
